import dayjs from "dayjs";
import "dayjs/locale/sk"; // load on demand
import striptags from "striptags";
import { campaignPage } from "grandus-lib/utils/fetches";
import { get, isArray, isEmpty, map } from "lodash";
import { Result, Typography } from "antd";
import {
  getCampaignLinkAttributes,
  getCampaignLinkAttributesFromRouter,
  paramsToPath,
} from "grandus-lib/hooks/useFilter";
import { FrownOutlined } from "@ant-design/icons";
import Countdown from "react-countdown";
import { countdownRenderer } from "utils";
import Link from "next/link";

import styles from "./campaign.page.module.scss";

import dynamic from "next/dynamic";
const Image = dynamic(() =>
  import("grandus-lib/components-atomic/image/Image")
);
const  ProductCard = dynamic(() =>
  import("components/product/card/ProductCard")
);
const Pagination = dynamic(() => import("components/pagination/Pagination"));
const MetaData = dynamic(() =>
  import("grandus-lib/components-atomic/MetaData")
);
const CategoryParameters = dynamic(
  () => import("components/category/CategoryParameters"),
  { ssr: false }
);
const CategoryOrdering = dynamic(
  () => import("components/category/CategoryOrdering"),
  { ssr: false }
);
const CategorySelected = dynamic(
  () => import("components/category/CategorySelected"),
  { ssr: false }
);

const handleGetData = (router, newState) => {
  const data = getCampaignLinkAttributes(
    get(router, "query.campaign"),
    paramsToPath(newState),
    get(router, "query"),
    { toDelete: ["campaign", "parameters", "page"] },
    router
  );

  return data;
};

const handleOrderingLinkAttributes = (router, ordering) => {
  return getCampaignLinkAttributesFromRouter(router, {
    dataToChange: { orderBy: ordering },
    toDelete: ["campaign", "parameters", "page"],
  });
};

const handlePaginationLinkAttributes = (router, data) => {
  return getCampaignLinkAttributesFromRouter(router, data);
};

const CampaignRow = ({ photo, name, urlName, description }) => (
  <Link href="/akcie/[campaign]/[[...parameters]]" as={`/akcie/${urlName}`}>
    <a className={`${styles.otherRow}`}>
      {photo ? (
        <div className={`image ${styles?.photo}`}>
          <Image photo={photo} size="80x80__cropped" type="jpg" />
        </div>
      ) : (
        ""
      )}
      <div className={styles?.rowRight}>
        <h4>{name}</h4>
        {description ? (
          <Typography.Paragraph ellipsis={{ rows: 2 }}>
            <div dangerouslySetInnerHTML={{ __html: striptags(description) }} />
          </Typography.Paragraph>
        ) : null}
      </div>
    </a>
  </Link>
);

const Campaign = ({
  campaigns,
  campaign,
  products,
  filter,
  meta,
  pagination,
}) => {
  return (
    <>
      <MetaData {...meta} />
      <main className={`wrapper products ${styles.campaign}`}>
        <div className={`container ${styles?.description}`}>
          <div className="row">
            <div className="col-12 col-md-7">
              <h1>{get(campaign, "name")}</h1>
              {campaign?.availableToTime ? (
                <Countdown
                  date={dayjs(campaign?.availableToTime)}
                  renderer={countdownRenderer(styles)}
                />
              ) : null}
              {campaign?.coverPhoto ? (
                <div className={`image ${styles?.coverPhoto}`}>
                  <Image photo={campaign?.coverPhoto} size={"590x210"} type="jpg" />
                </div>
              ) : (
                ""
              )}
              <div
                dangerouslySetInnerHTML={{
                  __html: get(campaign, "description", ""),
                }}
              />
            </div>
            <div className={`col-12 col-md-5 ${styles.alternativeCampaigns}`}>
              {!isEmpty(campaigns) ? (
                <>
                  <h3>Mohlo by Vás zaujímať</h3>
                  {map(campaigns, (campaign,index) => {
                    if(index > 4){
                      return ""
                    }
                    return(
                      <CampaignRow
                        {...campaign}
                        key={`other-campaigns-${campaign?.id}`}
                      />
                    )
                  }
                  )}
                </>
              ) : null}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="products-container">
            <aside
              className="sidebar"
              id="products-filter"
              style={{
                minHeight: "100px",
              }}
            >
              <CategoryParameters
                initialData={filter}
                handleGetData={handleGetData}
              />
            </aside>
            <section className="products">
              <CategorySelected handleGetData={handleGetData} />
              <CategoryOrdering
                handleLinkAttributes={handleOrderingLinkAttributes}
              />

              <div className="product-listing-grid" id="layout-grid">
                {isArray(products) && !isEmpty(products) ? (
                  <div className="row">
                    {products.map((product, index) => {
                      return (
                        <div
                          className="col-xl-3 col-md-6 column"
                          key={`product-card-${product.id}-${index}`}
                        >
                          <ProductCard
                            {...product}
                            options={{
                              eecProduct: {
                                position: index + 1,
                                page: pagination?.currentPage,
                                perPage: pagination?.perPage,
                              },
                            }}
                          />
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <Result
                    icon={<FrownOutlined />}
                    title="Ľutujeme, nenašli sa produkty"
                    subTitle={`Vášmu výberu nezodpovedaju žiadne produkty. Zmente prosím kategóriu alebo kombináciu filtrov.`}
                  />
                )}
              </div>

              <Pagination
                {...pagination}
                handleLinkAttributes={handlePaginationLinkAttributes}
              />
            </section>
          </div>
        </div>
      </main>
    </>
  );
};

export async function getServerSideProps(context) {
  return campaignPage.serverSideProps(context);
}

export default Campaign;
